import { createEvent, createStore } from 'effector';

export const calculatorStateChanged = createEvent<boolean>();

export const $calculatorOpenedStore = createStore(false).on(calculatorStateChanged, (_, isOpened) => isOpened);
